/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Grid, Skeleton, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@store/store";
import { InactivityHandler } from "@components/InactivityHandler";
import CustomRightImage from "@components/CustomRightImagev2";
import { BOFU_TABS_CONFIG } from "@helpers/constantes";
import { setBofuTabEmpresaDocument } from "@store/slices/bofuSlice";
import ButtonExpedienteStatus from "@components/ButtonExpedienteStatus";
import TabBofu from "@components/TabBofu/TabBofu";
import DocumentsTabBofu from "@components/TabBofu/DocumentsTabBofu";
import ButtonContinue from "@components/TabBofu/ButtonContinue";
import { CustomCompanyName } from "@components/CustomCompanyName";

const AvanceExpedienteDigitalPFAE: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  const bufuLoading = useSelector((state: RootState) => state.bofu.isLoading);
  const application = useSelector((state: RootState) => state.register.application);
  const bofuTabs = useSelector((state: RootState) => state.bofu.bofu_tabs_obj);

  const { solicitud_credito: showSolicitudCredito, referencias_personales: showReferencias, informacion_bancaria: showInformacionBancaria } =
    bofuTabs.empresa.forms;
  const showAnyEmpresaForm = showSolicitudCredito || showReferencias || showInformacionBancaria;

  return (
    <Grid container height="100%">
      <Grid item xs={12} md={8} mt={2}>
        <Box textAlign={"center"} mx={4}>
          <InactivityHandler />

          <CustomCompanyName />

          <TabBofu />

          {bufuLoading ? (
            <Box mt={4}>
              <Skeleton variant="rectangular" height={100} sx={{ borderRadius: 2 }} />
            </Box>
          ) : (
            <Box>
              {showAnyEmpresaForm && (
                <Box mt={2} display="flex" justifyContent="center">
                  <Typography
                    mt={2}
                    variant={isMobileOrTablet ? "body2" : "body1"}
                    sx={{ color: theme?.palette?.primary?.dark, fontSize: "16px", fontWeight: 600 }}
                  >
                    Muy bien, ahora llena los formatos relacionados a la empresa y a la persona
                  </Typography>
                </Box>
              )}

              {showSolicitudCredito && (
                <Box mt={2} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="body1" sx={{ flex: 1, textAlign: "left" }} color={theme?.palette?.primary?.dark}>
                    Solicitud de crédito
                  </Typography>

                  <ButtonExpedienteStatus
                    mode="form"
                    formStatus={application?.loan_application_information_status}
                    onClick={() => navigate("/producto/creditosimple/solicitud_credito_1PFAE")}
                  />
                </Box>
              )}

              {showReferencias && (
                <Box mt={2} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="body1" sx={{ flex: 1, textAlign: "left" }} color={theme?.palette?.primary?.dark}>
                    Referencias
                  </Typography>

                  <ButtonExpedienteStatus
                    mode="form"
                    formStatus={application?.references_status}
                    onClick={() => navigate("/producto/creditosimple/referencias_clientes_pfae")}
                  />
                </Box>
              )}

              {showInformacionBancaria && (
                <Box mt={2} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="body1" sx={{ flex: 1, textAlign: "left" }} color={theme?.palette?.primary?.dark}>
                    Información bancaria
                  </Typography>

                  <ButtonExpedienteStatus
                    mode="form"
                    formStatus={application?.bank_information_status}
                    onClick={() => navigate("/producto/creditosimple/info_bancaria_pfae")}
                  />
                </Box>
              )}

              {bofuTabs.empresa.documents.length > 0 && (
                <Box mt={4}>
                  <Typography
                    mt={4}
                    variant={isMobileOrTablet ? "body2" : "body1"}
                    sx={{ color: theme?.palette?.primary?.dark, fontSize: "16px", fontWeight: 600 }}
                  >
                    Ahora carga los siguientes documentos
                  </Typography>
                </Box>
              )}

              {bofuTabs.empresa.documents.length > 0 && (
                <Box mt={4}>
                  <DocumentsTabBofu
                    tabCode={BOFU_TABS_CONFIG.tab_empresa.code}
                    documents={bofuTabs?.empresa?.documents || []}
                    onChange={({ document, newValue }) => {
                      dispatch(
                        setBofuTabEmpresaDocument({
                          document,
                          newValue,
                          valueAction: undefined,
                          valueIndex: undefined,
                        }),
                      );
                    }}
                    onChangeMultiple={({ document, newValue, valueAction, valueIndex }) => {
                      dispatch(setBofuTabEmpresaDocument({ document, newValue, valueAction, valueIndex }));
                    }}
                  />
                </Box>
              )}

              <Box mt={4}>
                <ButtonContinue tabCode={BOFU_TABS_CONFIG.tab_empresa.code} />
              </Box>
            </Box>
          )}
        </Box>
      </Grid>
      {!isMobileOrTablet && (
        <Grid item xs={12} md={4}>
          <CustomRightImage />
        </Grid>
      )}
    </Grid>
  );
};

export default AvanceExpedienteDigitalPFAE;
